// Enhanced image file validation to prevent malicious file uploads
const isValidImageFile = (value) => {
  if (!value) {
    return true;
  } // Allow empty values

  // Check file extension (basic first check)
  const validExtensions = /\.(?:jpg|gif|png|bmp|jpeg)$/i;
  if (!value.toLowerCase().match(validExtensions)) {
    return false;
  }

  // Additional security check for file name
  const filename = value.toLowerCase();

  // Prevent files with multiple extensions that could bypass filters
  const suspiciousPatterns = [
    /\.php\./i,
    /\.asp\./i,
    /\.jsp\./i,
    /\.js\./i,
    /\.exe\./i,
    /\.bat\./i,
    /\.cmd\./i,
    /\.scr\./i,
    /\.vbs\./i,
    /\.com\./i,
    /\.pif\./i
  ];

  if (suspiciousPatterns.some((pattern) => pattern.test(filename))) {
    return false;
  }

  // Check for null bytes and other dangerous characters
  if (filename.includes('\0') || filename.includes('..') || filename.includes('/') || filename.includes('\\')) {
    return false;
  }

  return true;
};

export default {
  fn: isValidImageFile,
  message: 'Please choose a valid image file (JPG, PNG, GIF, BMP only)'
};
